import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="password-visibility"
export default class extends Controller {
  static targets = ["input", "iconShow", "iconHide"]

  connect() {
    this.showHideIcon();
  }

  toggle() {
    if (this.inputTarget.type === "password") {
      this.inputTarget.type = "text";
    } else {
      this.inputTarget.type = "password";
    }
    this.showHideIcon();
  }

  showHideIcon() {
    if (this.inputTarget.type === "password") {
      this.iconHideTarget.classList.add("hidden");
      this.iconShowTarget.classList.remove("hidden");
    } else {
      this.iconShowTarget.classList.add("hidden");
      this.iconHideTarget.classList.remove("hidden");
    }
  }
}
